module.exports = __webpack_public_path__ + "static/bab-mobile-home-dedac83c1d6a887e14eff3e2b06c2b72.png";